export class DeptDateHourRequest{
    date: string;
	hour: number;
	minutes?: number;
	deptCode: string;
	uid:string;
}